import { render, staticRenderFns } from "./AdvertismentCard.vue?vue&type=template&id=79c03d01"
import script from "./AdvertismentCard.vue?vue&type=script&lang=ts"
export * from "./AdvertismentCard.vue?vue&type=script&lang=ts"
import style0 from "./AdvertismentCard.vue?vue&type=style&index=0&id=79c03d01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports